import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

// ---- Admin token ----
export const ADMIN_TOKEN_KEY = "gq_admin_token";
export function setAdminToken(token) {
  if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
  else localStorage.removeItem(ADMIN_TOKEN_KEY);
}
export function getAdminToken() {
  return localStorage.getItem(ADMIN_TOKEN_KEY);
}
export function authHeaders() {
  const t = getAdminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

// ---- Client (tenant) token ----
export const CLIENT_TOKEN_KEY = "gq_client_token";
export function setClientToken(token) {
  if (token) localStorage.setItem(CLIENT_TOKEN_KEY, token);
  else localStorage.removeItem(CLIENT_TOKEN_KEY);
}
export function getClientToken() {
  return localStorage.getItem(CLIENT_TOKEN_KEY);
}
export function clientHeaders() {
  const t = getClientToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}
